import { type ReactNode } from "react";
import { cn, EmptyState } from "@tellescope/design-system";

export interface BlockEmptyStateProps {
  children: ReactNode;
  className?: string;
}

export const BlockEmptyState = ({ children, className }: BlockEmptyStateProps) => (
  <EmptyState size="compact" className={cn("max-h-24 w-full", className)}>
    <EmptyState.Subtitle>{children}</EmptyState.Subtitle>
  </EmptyState>
);
